/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */

import { MapCommandAttributes, MapCommandMenuItem } from '../types';
import { MapCommand } from './map-command.class';
import { map } from 'rxjs/operators';
import { merge, Observable, Subject } from 'rxjs';
import { MapCommandLocatorService } from './map-command-locator.service';
import { inject } from '@angular/core';

export class MapCommandHost {

    shouldDisplay$: Observable<boolean>;
    shouldDisable$: Observable<boolean>;
    hasMenu$: Observable<boolean>;
    widgetMenuItems$: Observable<MapCommandMenuItem[]>;
    deactivate$: Observable<void>;

    protected localDeactivate$ = new Subject<void>();

    private commandLocator: MapCommandLocatorService = inject(MapCommandLocatorService);


    protected setupCommand(commandName: string, attributes: MapCommandAttributes) {
        const command: MapCommand = this.commandLocator.create(commandName, attributes);
        if (!command) {
            throw new Error(`Could not obtain instance of ${commandName}`);
        }
        this.shouldDisplay$ = command.shouldDisplay$;
        this.shouldDisable$ = command.shouldDisable$;
        this.widgetMenuItems$ = command.menuItems$;
        this.hasMenu$ = this.widgetMenuItems$.pipe(map(i => i.length > 0));
        this.deactivate$ = merge(
            command.deactivate$.asObservable(),
            this.localDeactivate$.asObservable()
        );

        return command;
    }
}